var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.543 6.494H9.506V1.457c0-1.943-3.012-1.943-3.012 0v5.037H1.456c-1.941 0-1.941 3.012 0 3.012h5.038v5.037c0 1.943 3.012 1.943 3.012 0V9.506h5.037c1.942 0 1.942-3.012 0-3.012Z",
    fill: "#365063"
  })));
};

export { SvgPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjU0MzQgNi40OTM4N0g5LjUwNjA5VjEuNDU2NzZDOS41MDYwOSAtMC40ODU1ODcgNi40OTM3MiAtMC40ODU1ODcgNi40OTM3MiAxLjQ1Njc2VjYuNDkzODdIMS40NTY0NEMtMC40ODU0NzkgNi40OTM4NyAtMC40ODU0NzkgOS41MDYxMyAxLjQ1NjQ0IDkuNTA2MTNINi40OTM3MlYxNC41NDMyQzYuNDkzNzIgMTYuNDg1NiA5LjUwNjA5IDE2LjQ4NTYgOS41MDYwOSAxNC41NDMyVjkuNTA2MTNIMTQuNTQzNEMxNi40ODU1IDkuNTA2MTMgMTYuNDg1NSA2LjQ5Mzg3IDE0LjU0MzQgNi40OTM4N1oiIGZpbGw9IiMzNjUwNjMiLz4KPC9zdmc+Cg==";